// src/pages/SettingsPage/components/AddWorkspaceUserModal.tsx
import {
  Box,
  Button,
  MenuItem,
  Modal,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import * as R from "ramda";
import React, { useState } from "react";
import { useAppsFromAllSources, useAppIdToApp } from "../../../hook/settings";
import { WorkspaceUserFormData } from "./types/settings.types";

export const AddWorkspaceUserModal: React.FC<{
  setFormData: (setFormData: WorkspaceUserFormData) => any;
  formData: WorkspaceUserFormData;
  modalOpen: boolean;
  setModelOpen: (isOpen: boolean) => any;
  onSubmit: (config: { formData: WorkspaceUserFormData; appId: string }) => any;
  appId: string;
  appSelector?: boolean;
  appTextInput?: boolean;
}> = ({
  setFormData,
  formData,
  modalOpen,
  setModelOpen,
  onSubmit,
  appId,
  appSelector = false,
  appTextInput = false,
}) => {
  const [formErrors, setFormErrors] = useState<string[]>([]);
  const apps = useAppsFromAllSources();
  const appIdToApp = useAppIdToApp();
  const [selectedApp, setSelectedApp] = useState(appIdToApp(appId));
  const appName = selectedApp?.name;

  const validateForm = () => {
    const emailFormErrors = formData["email"] ? [] : ["email"];
    const nameFormErrors = formData["name"] ? [] : ["name"];
    // Add app-name validation if appTextInput is true
    const appNameFormErrors =
      appTextInput && !formData["app-name"] ? ["app-name"] : [];
    const formErrors = [
      ...emailFormErrors,
      ...nameFormErrors,
      ...appNameFormErrors,
    ];
    setFormErrors(formErrors);
    return formErrors.length === 0;
  };

  const setFormField = (key: keyof WorkspaceUserFormData, value: string) => {
    setFormData({ ...formData, [key]: value });
  };

  return (
    <Modal open={modalOpen}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Paper
          elevation={7}
          sx={{
            padding: "2rem",
            width: "40rem",
            gap: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant="h6">Add User To {appName}</Typography>
          <TextField
            value={formData["email"]}
            label="Email"
            placeholder="johndoe@gmail.com"
            error={R.includes("email", formErrors)}
            helperText={
              R.includes("email", formErrors) ? "Required" : undefined
            }
            onChange={(e) => setFormField("email", e.target.value)}
          />
          <TextField
            value={formData["name"]}
            label="Name"
            placeholder="John Doe"
            error={R.includes("name", formErrors)}
            helperText={R.includes("name", formErrors) ? "Required" : undefined}
            onChange={(e) => setFormField("name", e.target.value)}
          />
          {appTextInput && (
            <TextField
              value={formData["app-name"]}
              label="Workspace Name"
              placeholder="My Workspace"
              error={R.includes("app-name", formErrors)}
              helperText={
                R.includes("app-name", formErrors) ? "Required" : undefined
              }
              onChange={(e) => setFormField("app-name", e.target.value)} // Corrected key
            />
          )}
          {appSelector && (
            <Select value={selectedApp?.id ?? ""}>
              {apps.map((app) => {
                return (
                  <MenuItem
                    key={app.id}
                    onClick={() => {
                      setSelectedApp(app);
                    }}
                    value={app.id}
                  >
                    {app.name}
                  </MenuItem>
                );
              })}
            </Select>
          )}
          <Box>
            <Button
              onClick={() => {
                if (!validateForm()) return;
                const submitAppId = selectedApp?.id ?? appId;
                if (!submitAppId) return;
                onSubmit({ formData, appId: submitAppId });
                setModelOpen(false);
              }}
            >
              Add
            </Button>
            <Button onClick={() => setModelOpen(false)}>Cancel</Button>
          </Box>
        </Paper>
      </Box>
    </Modal>
  );
};
